export default __webpack_public_path__ + "static/media/2814  - BUGS.d640b4d6.jpeg";